import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "./client";

export interface PairCodeOut {
  code: string;
  deep_link: string;
  expires_at: string;
}

export function useIssuePairCode() {
  return useMutation<PairCodeOut, Error, void>({
    mutationFn: async () =>
      (await api.post<PairCodeOut>("/me/telegram/pair-code")).data,
  });
}

export function useUnpairTelegram() {
  const qc = useQueryClient();
  return useMutation<void, Error, void>({
    mutationFn: async () => {
      await api.delete("/me/telegram");
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["me"] });
    },
  });
}

export function useSendTestMessage() {
  return useMutation<{ ok: true }, Error, void>({
    mutationFn: async () =>
      (await api.post<{ ok: true }>("/me/telegram/test")).data,
  });
}
